export default __webpack_public_path__ + "static/media/gallery_09.26027421.jpg";